import { States } from "../App";
import * as Button from "./Buttons";

export function FloatingButtons({
  state,
  spinnerId,
  setState,
  hideCheckedEntries,
  setHideCheckedEntries,
}) {
  const floatingButtons = [];

  floatingButtons.push(
    <Button.ChooseSpinnerButton key={0} setState={setState} />,
  );

  if (spinnerId) {
    floatingButtons.push(
      <Button.EditSpinnerButton key={1} setState={setState} />,
    );
  }

  floatingButtons.push(<Button.AddSpinnerButton key={2} setState={setState} />);

  if (state === States.EditSpinner) {
    floatingButtons.push(
      <Button.HideCheckedEntriesButton
        key={3}
        hideCheckedEntries={hideCheckedEntries}
        setHideCheckedEntries={setHideCheckedEntries}
      />,
    );
  }

  if (state !== States.SpinTheWheel && spinnerId !== undefined) {
    floatingButtons.push(<Button.CloseButton key={4} setState={setState} />);
  }

  return <div className="floating-buttons">{floatingButtons}</div>;
}
